/* File: assets/section-social-proof.js */
(function () {
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  document.querySelectorAll('[data-sp]').forEach(function (root) {
    var track = root.querySelector('[data-sp-track]');
    var dotsWrap = root.querySelector('[data-sp-dots]');
    if (!track) return;

    var originalItems = Array.prototype.slice.call(track.querySelectorAll('[data-sp-item]'));
    if (!originalItems.length) return;

    // -------------------------
    // Loader helpers (under ATC)
    // -------------------------
    function ensureLoaderUI(item) {
      if (!item) return null;
      var btn = item.querySelector('[data-sp-atc]');
      if (!btn) return null;

      // Loader element sits just after the <staged-action> wrapper
      // We attach it inside the form container so it stays under button.
      var form = btn.closest('form');
      if (!form) return null;

      var existing = form.querySelector('.sp__atcLoader');
      if (existing) return existing;

      var wrap = document.createElement('div');
      wrap.className = 'sp__atcLoader';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.display = 'none';
      wrap.style.justifyContent = 'center';
      wrap.style.paddingTop = '10px';

      var dot = document.createElement('span');
      dot.className = 'sp__atcLoaderDot';
      // inline styles so NO css changes required
      dot.style.width = '18px';
      dot.style.height = '18px';
      dot.style.borderRadius = '999px';
      dot.style.border = '2px solid rgba(18,18,18,.25)';
      dot.style.borderTopColor = 'rgba(18,18,18,.85)';
      dot.style.display = 'inline-block';
      dot.style.animation = 'spSpin .7s linear infinite';

      // inject keyframes once
      if (!document.getElementById('spSpinStyle')) {
        var st = document.createElement('style');
        st.id = 'spSpinStyle';
        st.textContent = '@keyframes spSpin{to{transform:rotate(360deg)}}';
        document.head.appendChild(st);
      }

      wrap.appendChild(dot);

      // place it right after staged-action if possible, else end of form
      var staged = form.querySelector('staged-action');
      if (staged && staged.parentNode) {
        staged.parentNode.insertBefore(wrap, staged.nextSibling);
      } else {
        form.appendChild(wrap);
      }
      return wrap;
    }

    function showLoaderForItem(item) {
      var l = ensureLoaderUI(item);
      if (l) l.style.display = 'flex';
    }
    function hideLoaderForItem(item) {
      if (!item) return;
      var btn = item.querySelector('[data-sp-atc]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var l = form.querySelector('.sp__atcLoader');
      if (l) l.style.display = 'none';
    }

    // Bind loader to ATC clicks (only once per button)
    function bindLoaderHandlers() {
      items.forEach(function (item) {
        var btn = item.querySelector('[data-sp-atc]');
        if (!btn) return;
        if (btn.dataset.spLoaderBound === '1') return;
        btn.dataset.spLoaderBound = '1';

        btn.addEventListener('click', function () {
          // only show loader for ACTIVE card
          if (!item.classList.contains('is-active')) return;

          // show immediately
          showLoaderForItem(item);

          // auto-hide fallback in case theme events don't fire
          // (we'll hide earlier if we detect cart updated)
          setTimeout(function () {
            hideLoaderForItem(item);
          }, 4500);
        });

        // If your theme disables button during staged-action, also hide when it re-enables
        var observer = new MutationObserver(function () {
          // when button becomes enabled again, hide loader
          if (!btn.disabled) hideLoaderForItem(item);
        });
        observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      });
    }

    // Hide loader when cart changes (works for most Shopify themes)
    function bindCartUpdateHide() {
      if (window.__spCartHideBound) return;
      window.__spCartHideBound = true;

      var hideAll = function () {
        document.querySelectorAll('[data-sp-item]').forEach(function (it) {
          hideLoaderForItem(it);
        });
      };

      // Common theme events
      window.addEventListener('cart:updated', hideAll);
      window.addEventListener('cart:refresh', hideAll);
      window.addEventListener('cart:change', hideAll);

      // As a reliable fallback: intercept /cart/add + cart.js requests completion
      // (does not break anything; just hides loader after network completes)
      var _fetch = window.fetch;
      if (typeof _fetch === 'function') {
        window.fetch = function () {
          return _fetch.apply(this, arguments).then(function (res) {
            try {
              var url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
              url = String(url || '');
              if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change') !== -1) {
                setTimeout(hideAll, 120);
              }
            } catch (e) {}
            return res;
          });
        };
      }
    }

    // ---- Seamless loop (clone head/tail) ----
    var CLONES = 2;
    var head = originalItems.slice(0, CLONES).map(function (n) { return n.cloneNode(true); });
    var tail = originalItems.slice(-CLONES).map(function (n) { return n.cloneNode(true); });

    tail.forEach(function (n) { n.classList.add('is-clone'); track.insertBefore(n, track.firstChild); });
    head.forEach(function (n) { n.classList.add('is-clone'); track.appendChild(n); });

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-sp-item]'));
    var realCount = originalItems.length;

    // Build dots for REAL slides only
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < realCount; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () {
            scrollToRealIndex(idx, 'smooth');
          });
        })(i);
        dotsWrap.appendChild(b);
      }
    }

    function getInterval() {
      var ms = parseInt(getComputedStyle(root).getPropertyValue('--sp-autoplay'), 10);
      if (!ms || ms < 1000) return 0;
      return ms;
    }

    function getCenterX() {
      var r = track.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function getRealIndexFromItemIndex(itemIndex) {
      var real = (itemIndex - CLONES) % realCount;
      if (real < 0) real += realCount;
      return real;
    }

    // ✅ scroll ONLY inside track (no page scroll)
    function scrollToItemIndex(idx, behavior) {
      idx = clamp(idx, 0, items.length - 1);
      var el = items[idx];
      if (!el) return;

      var left = el.offsetLeft - (track.clientWidth - el.clientWidth) / 2;
      left = clamp(left, 0, track.scrollWidth - track.clientWidth);

      track.scrollTo({ left: left, behavior: behavior || 'smooth' });
    }

    function scrollToRealIndex(realIdx, behavior) {
      scrollToItemIndex(realIdx + CLONES, behavior || 'smooth');
    }

    var activeItemIndex = CLONES;

    function setActiveByClosest() {
      var centerX = getCenterX();
      var bestIdx = 0;
      var bestDist = Infinity;

      items.forEach(function (el, i) {
        var rect = el.getBoundingClientRect();
        var elCenter = rect.left + rect.width / 2;
        var dist = Math.abs(elCenter - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          bestIdx = i;
        }
      });

      items.forEach(function (el, i) {
        var isActive = i === bestIdx;
        el.classList.toggle('is-active', isActive);

        // Disable ATC for non-active
        var atc = el.querySelector('[data-sp-atc]');
        if (atc) atc.disabled = !isActive;

        // Hide loader if slide is not active
        if (!isActive) hideLoaderForItem(el);

        // Lazy play/pause videos: only active slide plays
        var vid = el.querySelector('.sp__video');
        if (vid) {
          if (isActive && vid.hasAttribute('data-sp-autoplay') && isInView) {
            // Load source if not yet loaded (preload="none")
            if (vid.preload === 'none') vid.preload = 'metadata';
            vid.play().catch(function () {});
          } else {
            vid.pause();
          }
        }
      });

      if (dotsWrap) {
        var realIdx = getRealIndexFromItemIndex(bestIdx);
        var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.sp__dot'));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === realIdx);
        });
      }

      activeItemIndex = bestIdx;
    }

    // Keep infinite loop without blank space
    function normalizeIfNeeded() {
      if (activeItemIndex < CLONES) {
        var realIdx = getRealIndexFromItemIndex(activeItemIndex);
        scrollToItemIndex(realIdx + CLONES, 'auto');
        return;
      }
      if (activeItemIndex >= CLONES + realCount) {
        var realIdx2 = getRealIndexFromItemIndex(activeItemIndex);
        scrollToItemIndex(realIdx2 + CLONES, 'auto');
      }
    }

    // ---- Autoplay only when visible ----
    var timer = null;
    var isInView = false;

    function start() {
      var interval = getInterval();
      if (!interval || !isInView) return;
      stop();
      timer = setInterval(function () {
        scrollToItemIndex(activeItemIndex + 1, 'smooth');
      }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function pause() { stop(); }
    function resume() { if (getInterval() && isInView) start(); }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('touchend', resume, { passive: true });

    var raf = null;
    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        setActiveByClosest();
        normalizeIfNeeded();
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // ---- Click-and-drag (mouse) scrolling ----
    var isDragging = false;
    var dragStartX = 0;
    var dragScrollLeft = 0;
    var dragMoved = false;

    track.addEventListener('mousedown', function (e) {
      // Ignore clicks on interactive elements inside the product card area
      if (e.target.closest('[data-sp-atc], [data-sp-mute], .sp__socBtn, .sp__prodLink')) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.pageX - track.offsetLeft;
      dragScrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none'; // disable snap while dragging
      track.style.scrollBehavior = 'auto';
      pause();
      e.preventDefault();
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var x = e.pageX - track.offsetLeft;
      var walk = x - dragStartX;
      if (Math.abs(walk) > 4) dragMoved = true;
      track.scrollLeft = dragScrollLeft - walk;
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
      // Snap to nearest slide after release
      requestAnimationFrame(function () {
        setActiveByClosest();
        scrollToItemIndex(activeItemIndex, 'smooth');
        resume();
      });
    }

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // Prevent link clicks after a drag
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    // IntersectionObserver
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isInView = entry.isIntersecting;
        if (isInView) {
          requestAnimationFrame(function () {
            setActiveByClosest();
            normalizeIfNeeded();
          });
          resume();
        } else {
          pause();
        }
      });
    }, { threshold: 0.2 });
    io.observe(root);

    // ---- Mute / Unmute toggle (one unmuted at a time) ----
    function bindMuteButtons() {
      var allMuteBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sp-mute]'));

      allMuteBtns.forEach(function (btn) {
        if (btn.dataset.spMuteBound === '1') return;
        btn.dataset.spMuteBound = '1';

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var item = btn.closest('[data-sp-item]');
          if (!item) return;
          var video = item.querySelector('.sp__video');
          if (!video) return;

          var shouldUnmute = video.muted;

          if (shouldUnmute) {
            // Mute all other videos first
            root.querySelectorAll('.sp__video').forEach(function (v) {
              v.muted = true;
            });
            // Reset all mute buttons
            allMuteBtns.forEach(function (b) {
              b.classList.remove('is-unmuted');
              b.setAttribute('aria-label', 'Unmute video');
            });

            // Unmute this one
            video.muted = false;
            btn.classList.add('is-unmuted');
            btn.setAttribute('aria-label', 'Mute video');
          } else {
            // Mute this video
            video.muted = true;
            btn.classList.remove('is-unmuted');
            btn.setAttribute('aria-label', 'Unmute video');
          }
        });
      });
    }

    // Init
    requestAnimationFrame(function () {
      scrollToItemIndex(CLONES, 'auto');
      setActiveByClosest();

      // bind loader logic after clones exist
      bindLoaderHandlers();
      bindCartUpdateHide();
      bindMuteButtons();

      if (getInterval() && isInView) start();
    });
  });
})();
